"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
const theme = {
  borderRadius: '50%',
  large: 40,
  medium: 32,
  overlayActive: 'overlay2',
  overlayHover: 'overlay1',
  small: 24
};
exports.theme = theme;
//# sourceMappingURL=Avatar.theme.js.map